import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const CheckinComplete = withLazyFallback(
  () => import('components/Patient/checkin/CheckinComplete')
);
const CheckinSteps = withLazyFallback(() => import('components/Patient/checkin/CheckinSteps'));
const PatientCheckinEditingSelector = withLazyFallback(
  () => import('components/Patient/checkin/EditingSelector')
);
const PatientCheckinLogin = withLazyFallback(() => import('components/Patient/checkin/Login'));
const PastForms = withLazyFallback(() => import('components/Patient/checkin/PastForms/PastForms'));
const PersonalID = withLazyFallback(
  () => import('components/Patient/checkin/PersonalId/PersonalId')
);
const PersonalInformationContainer = withLazyFallback(
  () => import('components/Patient/checkin/PersonalInfo/PersonalInfo')
);
const ReturnCheck = withLazyFallback(() => import('components/Patient/checkin/ReturnCheck'));
const Review = withLazyFallback(() => import('components/Patient/checkin/Review/Review'));
const CheckinForms = withLazyFallback(() => import('components/Patient/checkin/checkin_forms'));
const HipaaFormContainer = withLazyFallback(
  () => import('components/Patient/checkin/hipaa_form_container')
);
const Insurance = withLazyFallback(() => import('components/Patient/checkin/insurance'));
const SecurePayment = withLazyFallback(
  () => import('components/Patient/checkin/SecurePayment/SecurePayment')
);

const PayPrompt = withLazyFallback(() => import('components/Patient/checkin/payment/payPrompt'));
const PaySuccess = withLazyFallback(() => import('components/Patient/checkin/payment/paySuccess'));
const PreAuth = withLazyFallback(() => import('components/Patient/checkin/payment/preAuth'));

const CHECK_IN = [
  {
    path: 'checkin',
    element: <CheckinSteps />,
    children: [
      { path: 'choices', element: <PatientCheckinEditingSelector /> },
      { path: 'personal-info', element: <PersonalInformationContainer /> },
      { path: 'form/:id', element: <CheckinForms /> },
      { path: 'hipaa', element: <HipaaFormContainer /> },
      { path: 'personal-id', element: <PersonalID /> },
      { path: 'insurance', element: <Insurance /> },
      { path: 'login', element: <PatientCheckinLogin isCheckin={true} /> },
      { path: 'payment', element: <SecurePayment /> },
      { path: 'pre-auth', element: <PreAuth /> },
      { path: 'pay', element: <PayPrompt /> },
      { path: 'pay-success', element: <PaySuccess /> },
      { path: 'complete', element: <CheckinComplete /> },
      { path: 'review', element: <Review /> },
      { path: 'past', element: <PastForms /> },
      { path: 'return-check', element: <ReturnCheck /> },
      { path: '*', element: <NotFound portal="checkin" /> }
    ]
  }
];

export default CHECK_IN;
